import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function RootRedirect() {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return (
      <main style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading...</p>
      </main>
    );
  }

  if (authenticated) {
    return <Navigate to="/orders" replace />;
  }

  return <Navigate to="/login" replace />;
}
